import * as Yup from 'yup';
import { NULLABLE_STRING_VALIDATION_RULE } from '../common';

export const connectCircleValidationSchema = Yup.object().shape({
  circleAPIKey: NULLABLE_STRING_VALIDATION_RULE.required({
    key: 'form:validation_messages.required_with_label',
    values: { label: 'common:value' },
  }),
});
